export const AMENDMENT_CLEVERTAP_EVENT = {
  AMENDMENT: 'Amendment',
  AIR_UI_ACTION: 'Air_UI_Action',
}

export const AMENDMENT_AIR_UI_ACTION_NAMES = {
  SEARCH_ALTERNATE_CLICKED: 'Search Alternate clicked',
  PICK_ANOTHER_DATE: 'pick another date',
  CONTINUE_BOOKING: 'continue booking',
}

export const AMENDMENT_DATE_WARNING_POPUP_FIELDS = {
  page_name: 'flights_amendments',
  action_type: 'click',
  vertical: 'air',
}

export const AMENDMENT_SEARCH_ALTERNATE_VALIDATION_MESSAGES = {
  NO_PAX: 'Select at least one traveller',
  NO_JOURNEY: 'Select at least one journey',
  JOURNEY_DATES_INCOMPLETE: 'Select new dates for all selected journeys',
}

export const AMENDMENT_DATE_WARNING_CLEVERTAP_MESSAGES = {
  FLEXIFLY_OUT_OF_WINDOW: 'Flexifly_warning',
  INVERSE_DEPART: 'inverse_date_warning_depart',
  INVERSE_RETURN: 'inverse_date_warning_return',
  VAS_FLEXIFLY: 'inverse_date_warning_FLEXIFLY',
  VAS_FLEXIFLY_PRE: 'inverse_date_warning_FLEXIFLY_PRE',
  VAS_EZCANCEL_PLUS: 'inverse_date_warning_EZCANCEL_PLUS',
} as const

export type AmendmentDateWarningClevertapMessage =
  (typeof AMENDMENT_DATE_WARNING_CLEVERTAP_MESSAGES)[keyof typeof AMENDMENT_DATE_WARNING_CLEVERTAP_MESSAGES]

export const AMENDMENT_FETCH_TRAVELLER_EVENT_NAMES = {
  SELECT_DATE_PAGE_SHOWN: 'select_date_page_shown',
  SELECT_DATE_PAGE_ELIGIBILITY_FAILED: 'select_date_page_eligibility_failed',
  AMEND_API_FAILED: 'amend_api_failed',
}

export const AMENDMENT_CASE_POPUP_EVENT_NAMES = {
  POPUP_LOAD: 'a_popup_load',
  CASE_CREATION_SPECIAL_RT: 'case_creation_Special_rt',
  CASE_CREATION_SUBMIT_CLICKED: 'case_creation_Submit_clicked',
  CASE_CREATION_BACK_CLICKED: 'case_creation_back_clicked',
}

export const SELECT_DATE_PAGE_NAME = 'Select travellers'

export const SELECT_DATE_PAGE_API_FAILURE_FIELDS = {
  event_name: AMENDMENT_FETCH_TRAVELLER_EVENT_NAMES.AMEND_API_FAILED,
  source_page: 'select_date_page',
}

export const AMENDMENT_SELECT_DATES_STORAGE_KEYS = {
  CTAP_DATA: 'ctapData',
  NPS_DATA: 'npsData',
  GLOBAL_TRIP_ID: 'globalTripId',
  SEARCH_API_DATA: 'searchAPIData',
  PAX_COUNT_OBJECT: 'paxCountObject',
}
